import { ReactElement } from "react";
import styles from "./BoxEditor.module.scss";

export interface IBoxEditor {
  body: string;
}

const BoxEditor = ({ body }: IBoxEditor): ReactElement => {
  return (
    <div className={styles.box__container}>
      <div dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  );
};

export default BoxEditor;
